import { IconPack } from '@fortawesome/angular-fontawesome';

import { faChromecastIcon } from './custom-brands/fas-google-chromecast-icon';

export const freeBrandsSvgIconsPack: IconPack = {
  faChromecastIcon, // size matters, custom import!
};
